import qs from "query-string";
import { URL_PARAM_ORDERS } from "./urlHelper";

export function getOrderedQuery(query) {
  return qs.stringify(query, {
    sort: (a: any, b: any) => URL_PARAM_ORDERS.indexOf(a) - URL_PARAM_ORDERS.indexOf(b),
  });
}
